/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ParameterInputType {
  Number = 'Number',
  DropDown = 'DropDown',
  Check = 'Check',
  Radio = 'Radio'
}
